/**
 * 充值二次确认弹出层
 */
import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../../../lang';
import PbAjax from '../../../lib/pbajax';
import InvoiceInfo from './invoice';
import Modal from 'boron/ScaleModal';

let pbajax = new PbAjax();

const noop = function(){};

const style = {
    modalStyle: {
         width: '500px'
    },
    contentStyle: {
        width: '500px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
}

class RechargePop  extends Component {
    static defaultProps = {
        content: '',
        product: { },
        orderBank: lang.template('永豐銀行'),
        orderId: '', // 下单的订单号
        onHide: noop
    }
    constructor(props){
        super(props);
        
        this.state = {
            showType: 1 // 1: 确认信息；2: 发票明细；3：充值结果
        };
    }

    componentDidMount() {
        this.showModal();
    }
    
    onHide() {
        // 在隐藏动画执行完成之后再触发事件onConfirm
        if (this.status == 'confirm') {
            this.props.onConfirm();
        }
    }

    handleSubmit() {
        this.setState({
            showType: 2
        });
    }

    onSubmitSuccess(){
        let data = this.props.data;
        let backAddr = data.h5;
        let [actions, attrs] = backAddr.split('?');

        if (attrs) {
            let arr = attrs.split('&');
            // let inputs = [];

            arr = arr.map((item, i) => {
                // let [key, v] = item.split('=');

                // 由于此处参数的值有可能是md5加密串，有一定概率会出现多个等于号，后端没有转义,
                // 这会扰乱正常的参数取值，java无法修改历史渠道，要求前端处理
                // 此处改成切割第一个等于号的方式获取key和value
                const firstEqIdx = item.indexOf('=');
                const key = item.substr(0, firstEqIdx);
                const v = item.substr(firstEqIdx + 1);
                return '<input type="hidden" name="' + key + '" value="' + v + '" />';
            });

            let forms = [
                '<form method="post" action="' + actions + '">',
                ...arr,
                '</form>'
            ];
            let $form = $(forms.join(''));
            $(document.body).append($form);

            $form[0].submit();
        }
    }
    
    onClose() {
        this.hideModal();
        this.status = 'cancel';
    }

    showModal(){
        this.refs.modal.show();
    }

    hideModal(){
        this.refs.modal.hide();   
    }

    render() {
        let userInfo = UP.Global.getUser();
        let product = this.props.product;
        let showType = this.state.showType;
        let $popcontent;

        if (showType == 1) {
            $popcontent = (
                <div className="bank-pop bank-confirm-pop">
                    <div className="bank-pop-hd">
                        <h2>{lang.template('儲值訊息')}</h2>
                        <div className="close" onClick={()=>this.hideModal()}>x</div>
                    </div>
                    <div className="bank-pop-bd">
                        <dl className="detail-info">
                            <dd>
                                <label>{lang.template('儲值訊息：')}</label>
                                <span className="txt">{userInfo.username} ( {lang.template('Up帳號：<%=code%>', { code: userInfo.upliveCode})})</span>
                            </dd>
                            <dd>
                                <label>{lang.template('儲值額度：')}</label>
                                <span className="txt"><em>{product.amount}</em></span>
                            </dd>
                            <dd>
                                <label className="title">{lang.template('需匯款')}</label>
                                <div className="money">{product.currencySymbol}{product.money / 100}</div>
                            </dd>
                        </dl>
                        <div className="banklist">
                            <h3>{lang.template('選擇')}</h3>
                            <ul>
                                <li>
                                    <input className="channel-input" type="radio" defaultChecked="checked" readyOnly/> 
                                    <label>{this.props.orderBank}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="bank-pop-ft">
                        <button className="btn confirm" onClick={()=>this.handleSubmit()}>{lang.template('確認儲值')}</button>
                    </div>
                </div>
            );
        } else if(showType == 2 ) {
            $popcontent = <InvoiceInfo orderBank={this.props.orderBank}  orderId={this.props.orderId} product={this.props.product} onClose={this.onClose.bind(this)} onSubmitSuccess={this.onSubmitSuccess.bind(this)}/>;
        }
        
        return (
            <Modal 
                ref="modal"  
                closeOnClick={false}              
                onHide={this.onHide.bind(this)}
                modalStyle={style.modalStyle}  
                backdropStyle={style.backdropStyle} 
                contentStyle={style.contentStyle}
            >
                {$popcontent}
            </Modal>
        );
    }
}

module.exports = {
    create: function (cfg) {
        cfg = cfg || {};
        
        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();
        
        this.layer = ReactDOM.render(
            <RechargePop {...cfg} onHide={this.onHide.bind(this)}/>,
            mountNode
        );
    },
    onHide: function(){
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy : function () {
        ReactDOM.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};


// WEBPACK FOOTER //
// ./js/component/recharge/ccnet/index.js